import { css } from 'styled-components'
import { rem } from 'polished'

const Typography = css`
  b,
  strong {
    font-weight: ${props => props.theme.font.primary.weight.superBold};
  }

  p {
    margin-top: 0;
    margin-bottom: 0;

    & + & {
      margin-top: ${rem(24)};
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0;
    //To prevent unsemantic use heading not have sizes
    font-size: inherit;
    font-weight: ${props => props.theme.font.primary.weight.regular};
  }

  ol,
  ul {
    padding-inline-start: 0;
    margin-top: ${rem(24)};
    margin-inline-start: ${rem(20)};
  }

  dl {
    margin: 0;
  }

  dd {
    margin-inline-start: 0;
  }

  ::-webkit-input-placeholder,
  :-ms-input-placeholder,
  ::-ms-input-placeholder,
  ::-moz-placeholder {
    color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }

  sup, sub {
    line-height: .5;
  }

  /* These scripts have no italics, so stop the browser faking a slant; Latin text only stays italic where its font has a real italic */
  :lang(ar), :lang(he), :lang(ja), :lang(ko), :lang(zh) {
    font-synthesis-style: none;
  }

  /* CJK text can break after any character, so lines often end with one character on its own */
  html:lang(ja), html:lang(ko), html:lang(zh) {
    text-wrap-style: pretty;
  }

  /* Korean breaks between words; anywhere (not break-word) lets flex items and table cells still shrink below a long word */
  html:lang(ko) {
    word-break: keep-all;
    overflow-wrap: anywhere;
  }

  /* Japanese keeps small kana off line starts */
  html:lang(ja) {
    line-break: strict;
  }

  /* Chinese and Japanese messages have no spaces around placeholders, so the browser adds the gap between them and Latin text or digits */
  html:lang(ja), html:lang(zh) {
    text-autospace: normal;
  }
`

export default Typography
